<template>
  <div class="contenedor">
    <input
      
      type="file"
      
      @change="getImage($event)"
      multiple
    >
    
    <b-button
      size="sm"
      class="mt-1"
      @click="uploadFile">
      Subir Imagen
    </b-button>

    <div class="bds-jumbo">
  		
	  	  <div v-for="(image, key) in files">
	        <div :id="key">
            <button type="button" class="close" @click="removeImage(key)">
	    	      &times;
	          </button>
	          <img class="preview img-thumbnail" v-bind:ref="'image' +parseInt( key )" /> 
	           
	        </div>
	      </div>
  	  
  	</div> 
  </div>
</template>

<script>

import { mapActions,mapState } from 'vuex'
import { login } from '../../modules/login/actions'
export default {
  props:{
    ticketid:{
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      image: '',
      files:[],
    }
  },
  mounted(){
      this.login()
  },  
  computed:{
    //se usa isOk para saber si se sube la imagen correctamente para posteriormente enviar un popup al usuario
    //...mapState('ticket',['errorMessage','isOk']),
    ...mapState('login',['jwtImage']),
    ...mapState('images',['path'])
  },
  methods: {
    ...mapActions({
      _subirImagen: 'images/subirImagen',
      _login:'login/imagelogin',
      _checkjwt:'login/checkjwt',
      _savePath: 'images/savePath',

    }),
    getImage(event) {
      //Asignamos la imagen a  nuestra data
      //this.image = event.target.files[0];
      let f = event.target.files
      
      for (let i=0; i < f.length; i++)
      {
    	  this.files.push(f[i]);
	    }
      this.refreshDom()
      
    },
    async uploadFile(e) {
      let el = this;
      let arr = [];

      for (let i=0; i < el.files.length; i++){
        let payload = {
          'token': el.jwtImage,
          'image' : el.files[i],
          'id':el.ticketid
        }
        
        const looper = await this._subirImagen(payload)
          .then(response => {
            arr[i] = this.path
          })
        
      }//end for 
      let payload = {
        'images': arr,
        'id': el.ticketid
      }
      this._savePath(payload)

      this.$toasted.show('las imagene se subieron correctamente', { 
	 	    						theme: "bubble", 
	 	    						position: "top-right", 
	 	    						duration : 3000
                            })
    
             
    },
    /*funcion que remueve las imagenes */
    removeImage (i) {    	
		  this.files.splice(i,1)
      this.refreshDom()
    },
    refreshDom(){
      for (let i=0; i<this.files.length; i++)
	    {
		    let reader = new FileReader(); //instantiate a new file reader
		    reader.addEventListener('load', function(){
		      this.$refs['image' + parseInt( i )][0].src = reader.result;
		    }.bind(this), false);  //add event listener

    	reader.readAsDataURL(this.files[i]);
	    }
    },

    login(){
      
        this._login()
      
    }


  },
}
</script>

<style lang="scss" scoped>
.contenedor{
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.preview{
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  height: 100px;
		  width: 100px;
		}
.bds-jumbo{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
 
  margin-top: 1em;
  width: 100%;
  border-radius: 6px 6px;
  padding-left: 1em;
  padding-right: 1em;

}
</style>